export default {
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    authStatus: function() {
      return this.$store.getters.authStatus;
    },
    currentUser: function() {
      return this.$store.getters.user;
    },
    currentLobby: function() {
      return this.$store.getters.lobby;
    },
    notificationsCount: function() {
      return this.$store.getters.user
        ? this.$store.getters.user.notifications_count
        : 0;
    },
    isLocal: function() {
      return window.location.hostname == "queota.club";
    },
    isAnticheatRunning: function() {
      // return this.currentUser.ac_online;
      return true;
    },
    showPasswordOnboarding: function() {
      return (
        this.isLoggedIn &&
        ((this.currentUser.onboarding_done &&
          this.currentUser.change_password_needed) ||
          this.showChangePassword)
      );
    }
  }
}
